<template>
    <main id="machine-sheet-equipments" v-if="displayContent">
        <div class="wrapper">
            <template
                v-if="standardEquipments.length > 0 || optionEquipments.length > 0 || finitions.length > 0 || optionEquipmentsCategories.length > 0"
            >
                <div
                    class="titled-container has-no-top-margin"
                    v-if="standardEquipments.length > 0 && availableFinitions.length <= 1"
                >
                    <h2 class="title is-2">
                        {{ $t("standard_attachments") }}
                    </h2>
                    <equipment-list :products="standardEquipments" />
                </div>
                <div class="titled-container" v-if="optionEquipments.length > 0 && availableFinitions.length <= 1">
                    <h2 class="title is-2">
                        {{ $t("additional_optional_equipments") }}
                    </h2>
                    <equipment-list :products="optionEquipments" />
                </div>
                <div class="equipments-finishing-container" v-if="availableFinitions.length > 1">
                    <div class="columns is-vcentered equipments-finishing-header">
                        <div class="column is-narrow">
                            <h2 class="title is-2">
                                {{ $t("finishing_equipments") }}
                            </h2>
                        </div>
                        <div class="column is-full-tablet">
                            <div class="columns is-mobile is-multiline finishing-badge-container">
                                <div class="column is-narrow">
                                    <span
                                        class="finishing-badge has-shadow standard" :class="brandBackgroundColor"
                                    >S</span>
                                    {{ $t("standard") }}
                                </div>
                                <div class="column is-narrow">
                                    <span class="finishing-badge has-shadow optional with-border">O</span>
                                    {{ $t("optional") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="equipments-finishing"
                        :class="'has-'+availableFinitions.length+'-columns'"
                        v-for="finition in finitions"
                        :key="finition.code"
                    >
                        <div class="label-column">
                            <div class="label-column-wrap">
                                <div class="cell-title">
                                    <!--<h3 class="labels-title" :class="brandColor" @click="toggleColumn(finition.code)">{{ finition.label }}</h3>-->
                                    <h3 class="labels-title" :class="brandColor">{{ finition.label }}</h3>
                                </div>
                                <!--:class="{'hidden': columnIsHidden(finition.code)}"-->
                                <div
                                    class="cell"
                                    v-for="product in finition.products"
                                    :key="product.identifier"
                                >
                                    <span class="label-text">{{ product.name }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="slider-column">
                            <div class="mobile-slider-controls">
                                <button
                                    class="action previous"
                                    :class="{available: canGoPrevious()}"
                                    :aria-label="$t('previous')"
                                    @click.prevent="slidePrev()"
                                ></button>
                                <button
                                    class="action next"
                                    :class="{available: canGoNext()}"
                                    :aria-label="$t('next')"
                                    @click.prevent="slideNext()"
                                ></button>
                            </div>
                            <hooper
                                :ref="finition.code+'_slider'"
                                :itemsToShow="isPhone ? 1.1 : availableFinitions.length"
                                :mouseDrag="false"
                                :touchDrag="isPhone"
                                :wheelControl="false"
                                @slide="slideChanged($event)"
                            >
                                <slide v-for="availableFinition in availableFinitions" :key="availableFinition">
                                    <div class="badge-column">
                                        <div class="badge-column-wrapper">
                                            <div class="cell-title">
                                                <!-- Safe dynamic loading avec try/catch et cache -->
                                                <img
                                                    v-if="getLogo(availableFinition,'png')"
                                                    :src="getLogo(availableFinition,'png')"
                                                    :alt="availableFinition"
                                                    class="finishing-logo small"
                                                >
                                                <img
                                                    v-else-if="getLogo(availableFinition,'svg')"
                                                    :src="getLogo(availableFinition,'svg')"
                                                    :alt="availableFinition"
                                                    class="finishing-logo"
                                                >
                                            </div>
                                            <!--:class="{'hidden': columnIsHidden(finition.code)}"-->
                                            <div
                                                class="cell"
                                                v-for="product in finition.products"
                                                :key="product.identifier"
                                            >
                                                <span
                                                    class="finishing-badge not-available"
                                                    v-if="!product.finitions[availableFinition]"
                                                >-</span>
                                                <span
                                                    class="finishing-badge optional"
                                                    v-if="product.finitions[availableFinition] === 'option'"
                                                >O</span>
                                                <span
                                                    class="finishing-badge standard" :class="brandBackgroundColor"
                                                    v-if="product.finitions[availableFinition] === 'serie'"
                                                >S</span>
                                            </div>
                                        </div>
                                    </div>
                                </slide>
                            </hooper>
                        </div>
                    </div>
                </div>
                <div class="titled-container" v-if="optionEquipmentsCategories.length > 0">
                    <h2 class="title is-2">
                        {{ $t("option_equipments") }}
                    </h2>
                    <div class="columns">
                        <div
                            class="column" :key="optionEquipmentsCategory.code"
                            v-for="optionEquipmentsCategory in optionEquipmentsCategories"
                        >
                            <h3 class="option-equipments-title" :class="brandColor">{{ optionEquipmentsCategory.label
                                }}</h3>
                            <equipment-list :products="optionEquipmentsCategory.products" />
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="content-available-soon">
                    {{ $t('content_available_soon') }}
                </div>
            </template>
        </div>
    </main>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {Hooper, Slide} from 'hooper';
import '@/../node_modules/hooper/dist/hooper.css';

import productService from '@/services/serli/product'

import EquipmentList from "@/components/Equipment/EquipmentList.vue"

export default {
  name: 'MachineEquipmentsView',
  components: {
    Hooper,
    Slide,
    EquipmentList,
  },
  data() {
    return {
      displayContent: false,
      availableFinitions: [],
      finitions: [],
      standardEquipments: [],
      optionEquipments: [],
      optionEquipmentsCategories: [],
      currentSlide: 0,
      // Cache pour éviter de répéter les try/catch
      logosCache: {},
    }
  },
  computed: {
    ...mapState({
      productDatas: state => state.sheet.productDatas,
      isPhone: state => state.settings.isPhone,
      categories: state => state.settings.categories,
      countries: state => state.settings.countries,
      country: state => state.settings.country,
    }),
    ...mapGetters({
      localeKebabFormat: 'settings/localeKebabFormat'
    }),
    countryGroup() {
      let group = this.countries.find(c => c.code === this.country)
      if (group) return group.countryGroup
      else return null
    },
    // Image de repli en cas d'absence de logo spécifique
    fallbackLogo() {
      return require('@/assets/img/loader.gif');
    }
  },
  watch: {
    currentSlide() {
      this.finitions.forEach((finition) => {
        this.$refs[finition.code + '_slider'][0].slideTo(this.currentSlide);
      })
    }
  },
  created() {
    this.startLoading();
    this.fetchFinitions()
    .then(() => this.getStandardEquipments())
    .then(() => this.getOptionEquipments())
    .then(() => this.getOptionEquipmentsCategory())
    .finally(() => {
      this.displayContent = true;
      this.stopLoading()
    });
  },
  methods: {
    // Retourne le chemin si l'image existe, sinon null (avec try/catch)
    getLogo(name, ext) {
      const key = `${name}.${ext}`;
      if (Object.prototype.hasOwnProperty.call(this.logosCache, key)) {
        return this.logosCache[key];
      }
      let src = null;
      try {
        // Webpack résout statiquement le dossier; si le fichier n'existe pas, l'exception est attrapée
        src = require(`@/assets/img/finishing-logos/${key}`);
      } catch (e) {
        src = null;
      }
      this.$set ? this.$set(this.logosCache, key, src) : (this.logosCache[key] = src); // compat éventuelle
      return src;
    },
    async fetchFinitions() {
      const finitionCodes = [
        'finition_standard',
        'standard_standard',
        'standard_option',
        'classic_serie',
        'classic_option',
        'premium_serie',
        'premium_option',
        'elite_serie',
        'elite_option',
        'finition_essential_option',
        'finition_essential_standard',
        'platinum_standard',
        'platinum_option',
        'confort_serie',
        'confort_option',
        'confort_standard'
      ];

      let distinctFinitionProducts = [];
      let availableFinitions = [];
      finitionCodes.forEach(finitionCode => {
        let finitionCodeSplit = finitionCode.split('_');
        // Cas spécifique pour la finition essential, le nom des attributs différent des autres... donc on doit normaliser
        let finitionName = finitionCodeSplit[1] === 'essential' ? finitionCodeSplit[1] : finitionCodeSplit[0];

        if (this.productDatas.options[finitionCode]) {
          this.productDatas.options[finitionCode].forEach(finitionProduct => {
            if (!distinctFinitionProducts.includes(finitionProduct.code))
              distinctFinitionProducts.push(finitionProduct.code);
            if (!availableFinitions.includes(finitionName)) {
              availableFinitions.push(finitionName);
            }
          })
        }
      })
      this.availableFinitions = availableFinitions;

      let promisesArray = [];
      distinctFinitionProducts.forEach(distinctFinitionProduct => {
        promisesArray.push(productService.show(distinctFinitionProduct, {
          locale: this.localeKebabFormat
        }));
      })

      const distinctProductsDatas = await Promise.allSettled(promisesArray).then(responses => {
        let distinctProductsDatas = [];
        for (const response of responses) {
          if (response.value && response.value.data.data) {
            let valid = false
            let exceptionCountry = response.value.data.data.attributes.find(attr => attr.code === "exception_country")
            if (!exceptionCountry || (exceptionCountry.value && !exceptionCountry.value.find(except => except.code === this.countryGroup))) valid = true

            let exclusivCountry = response.value.data.data.attributes.find(attr => attr.code === "exclusiv_country")
            if (exclusivCountry && (exclusivCountry.value && !exclusivCountry.value.find(exclu => exclu.code === this.countryGroup))) valid = false

            if (valid) distinctProductsDatas.push(response.value.data.data)
          }
        }
        return distinctProductsDatas;
      });


      let finitions = [];
      distinctProductsDatas.forEach(distinctProductDatas => {

        let productDatas = distinctProductsDatas.find(x => x.identifier === distinctProductDatas.identifier);

        if (!finitions.find(x => x.code === productDatas.categories[0])) {

          const categorie = this.categories.find(x => x.code === productDatas.categories[0]);

          finitions.push({
            code: productDatas.categories[0],
            label: categorie.label,
            slideIndex: 0,
            isHidden: false,
            products: [],
          });
        }
        Object.assign(productDatas, {
          finitions: {
            classic: null,
            premium: null,
            elite: null,
            platinum: null,
            confort: null,
            standard: null
          }
        })

        finitionCodes.forEach(finitionCode => {
          if (this.productDatas.options[finitionCode] && this.productDatas.options[finitionCode].find(x => x.code === productDatas.identifier)) {
            let finitionCodeSplit = finitionCode.split('_');
            // Cas spécifique pour la finition essential, le nom des attributs différent des autres... donc on doit normaliser
            let finitionName = null;
            let finitionType = null;
            if (finitionCodeSplit[1] === 'essential') {
              finitionName = finitionCodeSplit[1];
              finitionType = (finitionCodeSplit[2] === 'standard' ? 'serie' : 'option');
            } else {
              finitionName = finitionCodeSplit[0];
              finitionType = finitionCodeSplit[1];
              if (finitionType === 'standard') finitionType = 'serie'
            }
            productDatas.finitions[finitionName] = finitionType
          }
        })

        const finitionCategoryIndex = finitions.findIndex(x => x.code === productDatas.categories[0])
        finitions[finitionCategoryIndex].products.push(productDatas);
        finitions[finitionCategoryIndex].products.sort((a, b) => a.name.localeCompare(b.name));
      })

      this.finitions = finitions.sort((a, b) => a.label.localeCompare(b.label));
    },
    async getStandardEquipments() {
      const finitionCodes = [
        'finition_standard',
        'standard_standard',
      ];
      let promisesArray = [];
      finitionCodes.forEach((code) => {


        if (this.productDatas.options[code]) {
          this.productDatas.options[code].forEach(finitionStandardProduct => {
            promisesArray.push(productService.machineOptions(finitionStandardProduct.code, {
              locale: this.localeKebabFormat
            }));
          })
        }
      })

      this.standardEquipments = await Promise.allSettled(promisesArray).then(responses => {
        let productsDatas = [];
        for (const response of responses) {
          if (response.value && response.value.data.data) {
            let valid = false
            let exceptionCountry = response.value.data.data.attributes.find(attr => attr.code === "exception_country")
            if (!exceptionCountry || (exceptionCountry.value && !exceptionCountry.value.find(except => except.code === this.countryGroup))) valid = true

            let exclusivCountry = response.value.data.data.attributes.find(attr => attr.code === "exclusiv_country")
            if (exclusivCountry && (exclusivCountry.value && !exclusivCountry.value.find(exclu => exclu.code === this.countryGroup))) valid = false

            if (valid) productsDatas.push(response.value.data.data)
          }
        }
        return productsDatas;
      });


      this.standardEquipments.sort((a, b) => a.name.localeCompare(b.name))

    },
    async getOptionEquipments() {
      const finitionCodes = [
        'standard_option',
      ];
      let promisesArray = [];
      finitionCodes.forEach((code) => {


        if (this.productDatas.options[code]) {
          this.productDatas.options[code].forEach(finitionOptionProduct => {
            promisesArray.push(productService.machineOptions(finitionOptionProduct.code, {
              locale: this.localeKebabFormat
            }));
          })
        }
      })

      this.optionEquipments = await Promise.allSettled(promisesArray).then(responses => {
        let productsDatas = [];
        for (const response of responses) {
          if (response.value && response.value.data.data) {
            let valid = false
            let exceptionCountry = response.value.data.data.attributes.find(attr => attr.code === "exception_country")
            if (!exceptionCountry || (exceptionCountry.value && !exceptionCountry.value.find(except => except.code === this.countryGroup))) valid = true

            let exclusivCountry = response.value.data.data.attributes.find(attr => attr.code === "exclusiv_country")
            if (exclusivCountry && (exclusivCountry.value && !exclusivCountry.value.find(exclu => exclu.code === this.countryGroup))) valid = false

            if (valid) productsDatas.push(response.value.data.data)
          }
        }
        return productsDatas;
      });

      this.optionEquipments.sort((a, b) => a.name.localeCompare(b.name))

    },
    async getOptionEquipmentsCategory() {
      if (this.productDatas.options.finition_option) {
        let promisesArray = [];
        this.productDatas.options.finition_option.forEach(finitionOptionProduct => {
          promisesArray.push(productService.machineOptions(finitionOptionProduct.code, {
            locale: this.localeKebabFormat
          }));
        })

        let optionEquipments = await Promise.allSettled(promisesArray).then(responses => {
          let productsDatas = [];
          for (const response of responses) {
            if (response.value && response.value.data.data) {
              let valid = false
              let exceptionCountry = response.value.data.data.attributes.find(attr => attr.code === "exception_country")
              if (!exceptionCountry || (exceptionCountry.value && !exceptionCountry.value.find(except => except.code === this.countryGroup))) valid = true

              let exclusivCountry = response.value.data.data.attributes.find(attr => attr.code === "exclusiv_country")
              if (exclusivCountry && (exclusivCountry.value && !exclusivCountry.value.find(exclu => exclu.code === this.countryGroup))) valid = false

              if (valid) productsDatas.push(response.value.data.data)
            }
          }
          return productsDatas;
        });


        let optionEquipmentsCategories = [];
        for (const optionEquipment of optionEquipments) {
          var catEquipment = optionEquipment.attributes.find(x => x.code === 'equipment_category')
          var codeEquipment = ''
          if (catEquipment) {
            codeEquipment = catEquipment.value.code
            if (!optionEquipmentsCategories.find(x => x.code === codeEquipment))
              optionEquipmentsCategories.push({
                code: catEquipment.value.code,
                label: catEquipment.value.label,
                products: []
              })
          } else {
            codeEquipment = optionEquipment.categories[0]
            if (!optionEquipmentsCategories.find(x => x.code === codeEquipment))
              optionEquipmentsCategories.push({
                code: codeEquipment,
                label: codeEquipment,
                products: []
              })
          }
          let optionEquipmentsCategoriesIndex = optionEquipmentsCategories.findIndex(x => x.code === codeEquipment)
          optionEquipmentsCategories[optionEquipmentsCategoriesIndex].products.push(optionEquipment);

        }

        this.optionEquipmentsCategories = optionEquipmentsCategories;

        this.optionEquipmentsCategories.sort((a, b) => a.label.localeCompare(b.label))

      }

    },
    slidePrev() {
      if (this.canGoPrevious())
        this.currentSlide--;
    },
    slideNext() {
      if (this.canGoNext())
        this.currentSlide++;
    },
    canGoPrevious() {
      return this.currentSlide > 0;
    },
    canGoNext() {
      return ((this.currentSlide + 1) < this.finitions.length);
    },
    slideChanged(payload) {
      this.currentSlide = payload.currentSlide;
    },
    /*toggleColumn(finitionCode) {
        this.finitions.find(x => x.code === finitionCode).isHidden = !this.columnIsHidden(finitionCode);
    },
    columnIsHidden(finitionCode){
        return this.finitions.find(x => x.code === finitionCode).isHidden;
    }*/
  }
}
</script>

<style lang="scss">
#machine-sheet-equipments {
    padding-top: 35px;
    padding-bottom: 30px;

    .equipments-finishing-container {
        margin-top: 70px;

        .equipments-finishing-header {
            margin-bottom: 50px;

            .finishing-badge-container {
                position: relative;
                z-index: 1;
                margin-left: 20px;

                @media #{$mq_phone} {
                    margin-left: 0;
                }

                .finishing-badge {
                    margin-right: 8px;
                }
            }
        }

        .equipments-finishing {
            display: flex;
            margin-bottom: 50px;

            &.has-4-columns {
                .label-column {
                    .label-column-wrap {
                        .cell {
                            &:after {
                                width: calc(((100vw - 30px) - ((100vw - 30px) / 8)));
                            }
                        }
                    }
                }
            }

            &.has-3-columns {
                .label-column {
                    .label-column-wrap {
                        .cell {
                            &:after {
                                width: calc(((100vw - 30px) - ((100vw - 30px) / 6)));
                            }
                        }
                    }
                }
            }

            &.has-2-columns {
                .label-column {
                    .label-column-wrap {
                        .cell {
                            &:after {
                                width: calc(((100vw - 30px) - ((100vw - 30px) / 2)));
                            }
                        }
                    }
                }
            }

            &.has-1-columns {
                .label-column {
                    .label-column-wrap {
                        .cell {
                            &:after {
                                width: calc(((100vw - 30px) - ((100vw - 30px) / 2)));
                            }
                        }
                    }
                }
            }

            .label-column {
                flex: 0 0 230px;

                @media #{$mq_phone} {
                    flex: 0 0 160px;
                    margin-left: -20px;
                }

                .label-column-wrap {
                    position: relative;

                    @media #{$mq_phone} {
                        margin-right: 20px;
                        padding: 0 10px;
                        box-shadow: 20px 0 34px 0 rgba(0, 0, 0, 0.05);

                        &:before {
                            content: '';
                            position: absolute;
                            top: -30px;
                            left: 0;
                            right: 0;
                            height: 30px;
                            z-index: 0;
                            background-color: $white;
                        }

                        &:after {
                            content: '';
                            position: absolute;
                            bottom: -30px;
                            left: 0;
                            right: 0;
                            height: 30px;
                            z-index: 0;
                            background-color: $white;
                        }
                    }


                    .cell-title {
                        position: relative;
                        display: flex;
                        height: 100px;
                        padding-bottom: 20px;
                        align-items: flex-end;
                        z-index: 1;

                        &:after {
                            display: none;
                        }

                        &.small {
                            height: 50px;
                        }

                        .labels-title {
                            @include medium-title;

                            @media #{$mq_phone} {
                                font-size: 18px;
                            }
                        }
                    }

                    .cell {
                        position: relative;
                        height: 80px;

                        &.hidden {
                            display: none;
                        }

                        &:after {
                            content: '';
                            position: absolute;
                            top: 8px;
                            left: 0;
                            z-index: 0;
                            height: 2px;
                            background-image: url('~@/assets/img/spaced-dot.svg');
                            background-position: center center;
                            background-repeat: repeat-x;
                            background-size: 7px 2px;

                            @media #{$mq_phone} {
                                width: 60vw;
                            }
                        }

                        .label-text {
                            position: relative;
                            z-index: 1;
                            font-size: 15px;
                            background-color: $white;

                            @media #{$mq_phone} {
                                font-size: 14px;
                            }
                        }
                    }
                }
            }

            .slider-column {
                position: relative;
                flex: 1 1 auto;

                .mobile-slider-controls {
                    display: none;
                    position: absolute;
                    top: -30px;
                    left: 0;
                    width: calc(100vw - 170px);

                    @media #{$mq_phone} {
                        display: block;
                    }

                    .action {
                        opacity: 0.2;
                        cursor: pointer;


                        &:after {
                            @include icomoon;
                            content: "\e918";
                            display: inline-block;
                            font-size: 22px;
                            color: $blackish;
                            transition: color 0.3s ease;
                        }

                        &.available {
                            opacity: 1;
                        }

                        &.previous {
                            float: left;

                            &:after {
                                transform: rotate(90deg);
                            }
                        }

                        &.next {
                            float: right;
                            margin-right: 25px;

                            &:after {
                                transform: rotate(-90deg);
                            }
                        }
                    }
                }

                .hooper {
                    height: auto;

                    .hooper-slide {
                        height: auto;
                        text-align: center;
                        max-width: 30%;

                        @media #{$mq_phone} {
                          max-width: 100%;
                        }
                    }
                }


                .badge-column {
                    margin: 0 auto;
                    padding: 0 20px;
                    max-width: 250px;
                    text-align: center;

                    @media #{$mq_phone} {
                        margin: 0;
                        padding: 0;
                    }

                    .badge-column-wrapper {
                        background-color: $light-grey;
                        border-radius: 20px;
                        margin: 0 5px;

                        .cell-title {
                            padding-top: 20px;
                            height: 100px;

                            &.small {
                                height: 50px;
                            }

                            .finishing-logo {
                                width: 80%;
                                height: auto;

                                @media #{$mq_phone} {
                                    width: 100%;
                                }

                                &.small {
                                    width: 65%;
                                    padding: 10px 0;
                                }
                            }
                        }

                        .cell {
                            height: 80px;

                            &.hidden {
                                display: none;
                            }

                            .finishing-badge {
                                margin-top: -17px;
                            }
                        }
                    }
                }
            }
        }
    }

    .option-equipments-title {
        @include medium-title
    }
}
</style>
